var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{staticClass:"mt-0 mb-0 pa-0",attrs:{"hide-details":""},on:{"change":_vm.changeValue},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }